import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

export const LibraryLayout = ({ children }) => {
  return (
    <Flex flexDirection="column">
      <Text variant="h4" sx={{
        lineHeight: '28px'
      }}>
        Content Library
      </Text>
      <Text
        variant="body1"
        sx={{
          marginTop: '8px',
          marginBottom: '32px',
          lineHeight: '24px'
        }}
      >
        View all generated and master content for your products. Click on a product to explore past generations, drafts, and master content.
      </Text>
      {children}
    </Flex>
  );
};
